interface CodToPrepaidType {
  availablePaymentMethods: string[];
  amount: number;
}

export const codToPrepaidDataTransformer = (data: CodToPrepaidType) => ({
  availablePaymentMethods: data.availablePaymentMethods,
  amount: data.amount,
});
